export const actionTypes = {
  SET_AUDIT_FLOW_SELECTION: "SET_AUDIT_FLOW_SELECTION",
  SET_AUTH: "SET_AUTH",
  SET_BUTTONSTATUS: "SET_BUTTONSTATUS",
  SET_COUNTRY_DATA: "SET_COUNTRY_DATA",
  SET_EDGES: "SET_EDGES",
  SET_ENTITY_DATA: "SET_ENTITY_DATA",
  SET_FLOWCONFIG: "SET_FLOWCONFIG",
  SET_FLOWLAYOUT: "SET_FLOWLAYOUT",
  SET_FOCUSID: "SET_FOCUSID",
  SET_MENU_SELECTION: "SET_MENU_SELECTION",
  SET_MODE: "SET_MODE",
  SET_NEWFLOWLAYOUTTRIGGER: "SET_NEWFLOWLAYOUTTRIGGER",
  SET_NODES: "SET_NODES",
  SET_POPUP: "SET_POPUP",
  SET_RESET: "SET_RESET",
  SET_SCREENSHOT_IMAGE: "SET_SCREENSHOT_IMAGE",
  SET_SCREENSHOT_IMAGE_DIMENSIONS: "SET_SCREENSHOT_IMAGE_DIMENSIONS",
  SET_SELECTED_COUNTRY: "SET_SELECTED_COUNTRY",
  SET_SHOWHANDLES: "SET_SHOWHANDLES",
  SET_SHOWSTYLE: "SET_SHOWSTYLE",
  SET_VERSION: "SET_VERSION",
};
